import React from "react";
import {Event} from "../../../../cp/components/Comet";
import {useEventContext} from "../EventContext";

export default () => {
    const {eventDispatch} = useEventContext();

    const onCreate = (data) => onUpdate(data);

    const onUpdate = (data) => eventDispatch((event) => {
        const newEvent = {...event};
        const index = newEvent.stream.findIndex(({id}) => id === data.id);
        if (index >= 0) {
            const newStream = {...newEvent.stream[index]};
            for (let key in data) {
                if (!(data[key] instanceof Object)) {
                    newStream[key] = data[key];
                }
            }
            if (newStream.color && newStream.color[0] !== "#") {
                newStream.color = "#" + newStream.color;
            }
            newEvent.stream[index] = newStream;
        } else {
            const newStream = {...data};
            if (newStream.color && newStream.color[0] !== "#") {
                newStream.color = "#" + newStream.color;
            }
            newEvent.stream.push(newStream);
        }

        return newEvent;
    });

    const onUpdateQuality = (data) => eventDispatch((event) => {
        const updatedStreams = event.stream.map(stream => {
            if (stream.id === data.streamId) {
                return {
                    ...stream,
                    quality: stream.quality.map(quality =>
                        quality.id === data.id ? data : quality
                    ),
                };
            }
            return stream;
        });

        return {
            ...event,
            stream: updatedStreams,
        };
    });

    const onDelete = (data) => eventDispatch((event) => {
        const newEvent = Object.assign({}, event);
        newEvent.stream = newEvent.stream.filter(({id}) => id !== data.id);
        return newEvent;
    });

    return (
        <>
            <Event event="create:stream" handler={(data) => onCreate(data)} />
            <Event event="update:stream" handler={(data) => onUpdate(data)} />
            <Event event="update:stream/quality" handler={(data) => onUpdateQuality(data)} />
            <Event event="delete:stream" handler={(data) => onDelete(data)} />
        </>
    );
}
